/**
 * Converts a string from camelCase or PascalCase to snake_case
 */
function transformToSnakeCase(str: string): string {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}

/**
 * Recursively converts all object keys to snake_case
 * This ensures consistent property naming in PostHog events regardless of how
 * properties are named in TypeScript code (camelCase, PascalCase, etc.)
 */
function convertKeysToSnakeCase(obj: unknown): unknown {
  if (obj === null || obj === undefined) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => convertKeysToSnakeCase(item));
  }

  if (typeof obj === 'object') {
    return Object.entries(obj).reduce(
      (acc, [key, value]) => {
        const snakeKey = transformToSnakeCase(key);
        acc[snakeKey] = convertKeysToSnakeCase(value);
        return acc;
      },
      {} as Record<string, unknown>
    );
  }

  return obj;
}

const analyticsHelpers = { convertKeysToSnakeCase };
export default analyticsHelpers;
